import TeamLogoCard from "./TeamLogoCard";

import { appAssets } from "../../config/assets";

const teams = [
    { id: "camerlux", name: "Camerlux", logo: appAssets.teams.camerlux },
    { id: "csgl", name: "CSGL", logo: appAssets.teams.guinee },
    { id: "fpm237", name: "FPM 237", logo: appAssets.teams.fpm237 },
    { id: "capvert", name: "Cap Vert", logo: appAssets.teams.capvert },
    { id: "hesper", name: "Hespérance", logo: appAssets.teams.hesper },
    { id: "senegal", name: "Sénégal", logo: appAssets.teams.senegal },
    { id: "soudan", name: "Soudan", logo: appAssets.teams.soudan },
    { id: "gambie", name: "Gambie", logo: appAssets.teams.gambie },
    { id: "lions", name: "Lions Ind.", logo: appAssets.teams.lions },
];

export default function TeamsShowcaseSection() {
    return (
        <section className="w-full border-t border-cyan-500/20 bg-[#071120] py-4">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mb-3">
                    <h2 className="text-lg font-bold text-white md:text-xl">Équipes</h2>
                </div>

                <div className="grid grid-cols-9 gap-3">
                    {teams.map((team) => (
                        <TeamLogoCard key={team.name} name={team.name} logo={team.logo} />
                    ))}
                </div>
            </div>
        </section>
    );
}